import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { changePwd } from '../../../common/api';
import { toast } from 'react-toastify';
import InputGroup from 'react-bootstrap/InputGroup';
import { FaEye, FaEyeSlash } from 'react-icons/fa';


import '../modals.css';

const ChangePwd = ( { close, aid, uid } ) => {
    const nav = useNavigate();

    const [ curPwd, setCurPwd ] = useState( '' );
    const [ showCur, setShowCur ] = useState( false );
    const [ newPwd, setNewPwd ] = useState( '' );
    const [ showNew, setShowNew ] = useState( false );
    const [ confirmPwd, setConfirmPwd ] = useState( '' );
    const [ showConfirm, setShowConfirm ] = useState( false );
    const [ allowChange, setAllowChange ] = useState( false );
    const [ processing, setProcessing ] = useState( false );

    const makeChange = async () => {
        setProcessing( true );
        const changed = await changePwd( aid, uid, curPwd, newPwd );
        if ( changed.length ) {
            toast.success( `Your password has been updated`, { theme: 'dark' } );
            close();
        } else {
            alert( 'Sorry, but your password was not updated ... please check your current password and try again.' );
            setProcessing( false );
        }
    }

    useEffect( () => {
        if ( curPwd && curPwd.length && newPwd && newPwd.length ) {
            if ( newPwd === confirmPwd ) {
                setAllowChange( true );
            } else {
                setAllowChange( false );
            }
        }
    }, [ curPwd, newPwd, confirmPwd ] );

    return (
        <Fragment>
            <Modal.Header closeButton>
                <Modal.Title>Change Your Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                processing ? (
                    <Fragment>
                        <Row className='py-3'>
                            <Col className='text-center'>
                                <Spinner animation="border" variant='primary' role="status" />
                            </Col>
                        </Row>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Current Password</Form.Label>
                                    <InputGroup>    
                                        <Form.Control className='tf-login-input' type={ showCur ? 'text' : 'password' } placeholder="Enter your password" onChange={ ( e ) => setCurPwd( e.target.value ) } value={curPwd} />
                                        <InputGroup.Text onClick={ () => setShowCur( !showCur ) } style={ { cursor: 'pointer' } }>{ showCur ? <FaEyeSlash /> : <FaEye /> }</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>New Password</Form.Label>
                                    <InputGroup>    
                                        <Form.Control className='tf-login-input' type={ showNew ? 'text' : 'password' } placeholder="Enter your password" onChange={ ( e ) => setNewPwd( e.target.value ) } value={newPwd} />
                                        <InputGroup.Text onClick={ () => setShowNew( !showNew ) } style={ { cursor: 'pointer' } }>{ showNew ? <FaEyeSlash /> : <FaEye /> }</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs='auto'>
                                <Form.Group>
                                    <Form.Label>Confirm New Password</Form.Label>
                                    <InputGroup>    
                                        <Form.Control className='tf-login-input' type={ showConfirm ? 'text' : 'password' } placeholder="Enter your password" onChange={ ( e ) => setConfirmPwd( e.target.value ) } value={confirmPwd} />
                                        <InputGroup.Text onClick={ () => setShowConfirm( !showConfirm ) } style={ { cursor: 'pointer' } }>{ showConfirm ? <FaEyeSlash /> : <FaEye /> }</InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col>
                                <Button size='sm' variant='outline-primary' onClick={ () => makeChange() } disabled={!allowChange}>Update Pwd</Button>
                            </Col>
                        </Row>
                    </Fragment>
                )
            }
            </Modal.Body>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( ChangePwd );